import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import {mapActions, mapState} from 'vuex'
// import dateUtils from '../../../../common/utils/dateUtil'
import moment from 'moment'

export default {
  data () {
    return {
      searchInput: '',
      centerHeight: document.documentElement.clientHeight - 130 +'px',
      num : 10
    }
  },
  computed: {
    ...mapState('productSearchModule', ['productHistory']),
    productHistoryInfo () {
      return this.productHistory
    }
  },
  methods: {
    ...mapActions('productSearchModule', ['productSearchInfo']),
    goBack (item) {
      this.$router.push({
        path: RoutePathConstants.POINTS_MAIL_HOME_PAGE,
        query: {
        }
      })
    },
    getMore () {
      this.num +=5
    },
    openProductHomePage (value) {
      this.searchInput = value
      this.search()
    },
    dateFormat (time) {
      return time ? moment(time).format('YYYY/MM/DD') : ''
    },
    search () {
      this.$router.push({
        path: RoutePathConstants.POINTS_MAIL_HOME_PAGE,
        query: {
          searchInput: this.searchInput
        }
      })
    },
    productSearch () {
      this.productSearchInfo()
    }
  },
  mounted () {
    this.productSearch()
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/product-search/views/product-search.js